if (!customElements.get('neo-faq-tabs')) {
  customElements.define(
    'neo-faq-tabs',
    class NeoFaqTabs extends HTMLElement {
      connectedCallback() {
        if (this.dataset.neoFaqInitialized === 'true') return;

        this.nav = this.querySelector('[data-neo-faq-nav]');
        this.panelsContainer = this.querySelector('[data-neo-faq-panels]');
        this.tabs = Array.from(this.querySelectorAll('[data-neo-faq-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-neo-faq-panel]'));

        if (!this.nav || !this.panelsContainer || !this.tabs.length) return;

        this.dataset.neoFaqInitialized = 'true';
        this.onClick = this.handleClick.bind(this);
        this.onKeydown = this.handleKeydown.bind(this);
        this.onBlockSelect = this.handleBlockSelect.bind(this);

        this.tabs.forEach((tab) => this.nav.appendChild(tab));
        this.addEventListener('click', this.onClick);
        this.nav.addEventListener('keydown', this.onKeydown);
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.panels.forEach((panel) => this.initializeAccordions(panel));
        this.activateTab(0, false);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.nav?.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      handleClick(event) {
        const tab = event.target.closest('[data-neo-faq-tab]');

        if (tab && this.contains(tab)) {
          this.activateTab(this.tabs.indexOf(tab));
          return;
        }

        const toggle = event.target.closest('[data-neo-faq-toggle]');
        if (!toggle || !this.contains(toggle)) return;

        const item = toggle.closest('[data-neo-faq-item]');
        if (!item) return;

        const shouldOpen = !item.hasAttribute('data-neo-faq-open');
        this.setAccordionState(item, shouldOpen, true);
      }

      handleKeydown(event) {
        const currentTab = event.target.closest('[data-neo-faq-tab]');
        if (!currentTab) return;

        const currentIndex = this.tabs.indexOf(currentTab);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === currentIndex) return;

        event.preventDefault();
        this.activateTab(nextIndex);
        this.tabs[nextIndex].focus();
      }

      handleBlockSelect(event) {
        if (!this.contains(event.target)) return;

        const panel = event.target.closest('[data-neo-faq-panel]');
        if (!panel) return;

        const panelIndex = this.panels.indexOf(panel);
        if (panelIndex > -1) this.activateTab(panelIndex, false);
      }

      activateTab(index, scroll = true) {
        if (index < 0 || index >= this.tabs.length) return;

        this.tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === index;
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel, panelIndex) => {
          panel.hidden = panelIndex !== index;
        });

        if (scroll) {
          this.tabs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      }

      initializeAccordions(panel) {
        panel.querySelectorAll('[data-neo-faq-item]').forEach((item) => {
          const shouldOpen = item.dataset.neoFaqDefaultOpen === 'true';
          this.setAccordionState(item, shouldOpen);
        });
      }

      setAccordionState(item, isOpen, animate = false) {
        const toggle = item.querySelector('[data-neo-faq-toggle]');
        const content = item.querySelector('[data-neo-faq-content]');

        item.toggleAttribute('data-neo-faq-open', isOpen);
        toggle?.setAttribute('aria-expanded', String(isOpen));
        content?.setAttribute('aria-hidden', String(!isOpen));

        if (!content) return;

        if (window.jQuery) {
          const $content = window.jQuery(content).stop(true, true);

          if (animate) {
            $content[isOpen ? 'slideDown' : 'slideUp'](300);
          } else {
            $content[isOpen ? 'show' : 'hide']();
          }
          return;
        }

        content.style.display = isOpen ? 'block' : 'none';
      }
    }
  );
}
